import { render, staticRenderFns } from "./WorkgroupOrders.vue?vue&type=template&id=bb37393a&scoped=true"
import script from "./WorkgroupOrders.vue?vue&type=script&lang=js"
export * from "./WorkgroupOrders.vue?vue&type=script&lang=js"
import style0 from "./WorkgroupOrders.vue?vue&type=style&index=0&id=bb37393a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb37393a",
  null
  
)

export default component.exports